import { Component, Input } from '@angular/core';
import { CompatibilityType } from '@shared/services/browser-compatibility/compatibility.enum';

@Component({
  selector: 'app-compatibility',
  templateUrl: './compatibility.component.html',
  styleUrls: ['./compatibility.component.scss'],
  standalone: false
})
export class CompatibilityComponent {

  @Input()
  public compatibility: CompatibilityType;

  public CompatibilityType = CompatibilityType;

}
